import axiosInstance from "../index";

/**
 * Get member profile details for current logged in user
 * @param 
 * @returns 
 */
export const fetchMemberProfile = async (): Promise<any> => {
    try {
        const { data } = await axiosInstance.get(`/hub/user/profile/member`)
        return Promise.resolve(data);
    } catch (err) {
        return Promise.reject(err);
    }
}

/**
 * Generates a PDF file.
 * @return {Promise<any>} A promise that resolves with the generated PDF data.
 */
export const generateTosPdf = async(): Promise<any> => {
    try {
        const url =`/hub/user/tos?isFromRegistration=true`; 
        const { data } = await axiosInstance.get(url);
        return Promise.resolve(data);
    } catch (error) {
        return Promise.reject(error)
    }
}
